import request from '@/utils/request';
export function upList(data) {
  return request.post('admin/audit/insurance-review/up-list', data);
}
export function progressInfo(data) {
  return request.post('admin/audit/insurance-review/progress', data);
}
export function upInfo(data) {
  return request.post('admin/audit/insurance-review/detail', data);
}
export function insuranceApprove(data) {
  return request.post('admin/audit/insurance-review/approve', data);
}